<template>
  <Dropdown
    :label="t('Order status')"
    :items="localizedStatuses"
    item-title="title"
    item-value="id"
    :return-object="true"
    :disabled="saveInProgress || disabled"
    :model-value="orderStatusId"
    @update:modelValue="onStatusChange"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import Dropdown from '@/components/input-components/Dropdown.vue';
import { useI18n } from 'vue-i18n';

interface Status {
  id: string;
  name: string;
}

interface Order {
  statusId: string | null;
}

const { statuses = [], order, saveInProgress, disabled = false } = defineProps<{
  statuses?: Status[];
  order: Order;
  saveInProgress: boolean;
  disabled?: boolean;
}>();

const { t } = useI18n();

const localizedStatuses = computed(() =>
  statuses.map(s => ({
    ...s,
    title: t(s.name),
  }))
);

const orderStatusId = computed<Status | null>({
  get() {
    return localizedStatuses.value?.find(s => s.id === order.statusId) ?? null;
  },
  set(val) {
    order.statusId = val?.id ?? null;
  }
});

function onStatusChange(selected: Status) {
  order.statusId = selected.id;
}
</script>
